"use client";
import { BLOCKS_REGISTRY, BlockProps } from "./registry";


type Block = { id?: number | string; __component?: string; [k: string]: any };

export default function BlockManager({ blocks }: { blocks: Block[] }) {
  if (!Array.isArray(blocks) || blocks.length === 0) return null;

  return (
    <>
      {blocks.map((block, i) => {
       // console.log(`Rendering block ${i}:`, block?.__component, block);
        const Comp = block?.__component
          ? BLOCKS_REGISTRY[block.__component as keyof typeof BLOCKS_REGISTRY]
          : undefined;

        const key = `${block?.__component ?? "unknown"}-${
          block?.documentId ?? i
        }`;

        if (!Comp) return <div><h1 className='text-pink text-2xl p-4' >ce block n'existe pas</h1></div>;

        return <Comp key={key} data={block} />;
      })}
    </>
  );
}
